/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleAUpIcon20Solid = forwardRef('ArrowShapeTriangleAUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.631 14H5.368a1 1 0 0 1-.832-1.555l4.632-6.947a1 1 0 0 1 1.664 0l4.631 6.947A1 1 0 0 1 14.631 14Z" })));
});
